import { FC, ReactNode } from 'react'

import { FiltersSharedProps } from '@new/__global/components/Filters/Filters.types'

export interface FilterRenderingComponentProps<ValueType> extends FiltersSharedProps {
  activeValue?: ValueType
  initialValue?: ValueType // for backward compatibility with existing filters
  getFilterValue?: (id: string) => any
  id: string
  onChange: (selectedValues?: ValueType) => void
  label?: string
}

export interface FilterConfig<ValueType = string> {
  id: string // used for generating set of active filters for data queries
  label?: string
  queryParamName: string // should be kebab-case, used as url param name
  parser?: (value: string) => unknown
  formatter?: (value?: ValueType) => string
  component?: FC<FilterRenderingComponentProps<ValueType>> // component rendering filter UI
  customComponentProps?: object
  defaultValue?: unknown
  filterPreviewFormatter?: (value: ValueType) => ReactNode
  filterPreviewNoCapitalization?: boolean
  filterOutputFormatter?: (value: ValueType) => unknown
  showOnTheTopFiltersBar: () => boolean
  showOnTheSidePanel?: () => boolean
  showOnColumnHeader?: () => boolean
  showOnTheAppliedFilters?: (value: ValueType) => boolean
  groupId?: string
  filterAsColumnKey?: ExtendedColumnKey
}

export interface FiltersForPreview {
  id: string
  label?: string
  filterPreviewFormatter: FilterConfig<unknown>['filterPreviewFormatter']
  filterPreviewNoCapitalization?: boolean
  onClear: VoidFunction
}

export enum ExtendedColumnKey {
  bathroomsCount = 'bathroomsCount',
  bedroomsCount = 'bedroomsCount',
  maxOccupancy = 'maxOccupancy',
  distance = 'distance',
  revenueModel = 'revenueModel',
  status = 'status',
  cleanStatus = 'cleanStatus',
  inspectStatus = 'inspectStatus',
  casesStatus = 'casesStatus',
  attentionBadges = 'operationTags',
  note = 'note',
  petPolicy = 'petPolicy',
}

export enum SortOrderKey {
  ascending = 'asc',
  descending = 'desc',
}
